// extracted by mini-css-extract-plugin
export default {"label":"CheckboxComponent_label_seVhc","input":"CheckboxComponent_input_raYWr","icon":"CheckboxComponent_icon_IhwEw","text":"CheckboxComponent_text_plEMr"};